import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import './AccountSetup.css';

const AccountSetup = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { login } = useAuth();
    const [formData, setFormData] = useState({
        firstName: location.state?.userData?.firstName || '',
        lastName: location.state?.userData?.lastName || '',
        password: '',
        confirmPassword: '',
        accountType: 'individual' // Default to individual
    });

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Check if user came from Google OAuth
        const tempToken = localStorage.getItem('tempToken');
        if (!tempToken && !location.state?.fromGoogle) {
            navigate('/login');
        }
    }, [navigate, location.state]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const tempToken = localStorage.getItem('tempToken');
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/auth/complete-setup`,
                {
                    ...formData,
                    tempToken
                }
            );

            if (response.data.success) {
                // Clear temporary data
                localStorage.removeItem('tempToken');
                localStorage.removeItem('tempUserData');
                
                // Set permanent token and login
                localStorage.setItem('token', response.data.token);
                login(response.data.user);
                
                // Redirect based on account type
                navigate(formData.accountType === 'individual' ? '/dashboard' : '/corporate-setup');
            }
        } catch (error) {
            console.error('Setup error:', error);
            // Handle error...
        }
    };

    return (
        <div>
            <h2>Complete Your Account Setup</h2>
            <form onSubmit={handleSubmit}>
                {/* Name fields (pre-filled from Google) */}
                <input
                    type="text"
                    value={formData.firstName}
                    onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                    placeholder="First Name"
                    required
                />
                <input
                    type="text"
                    value={formData.lastName}
                    onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                    placeholder="Last Name"
                    required
                />
                
                {/* Account type selection */}
                <div>
                    <label>
                        <input
                            type="radio"
                            name="accountType"
                            value="individual"
                            checked={formData.accountType === 'individual'}
                            onChange={(e) => setFormData({...formData, accountType: e.target.value})}
                        />
                        Individual Account
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="accountType"
                            value="corporate"
                            checked={formData.accountType === 'corporate'}
                            onChange={(e) => setFormData({...formData, accountType: e.target.value})}
                        />
                        Corporate Account
                    </label>
                </div>

                {/* Password setup */}
                <input
                    type="password"
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    placeholder="Create Password"
                    required
                />
                <input
                    type="password"
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
                    placeholder="Confirm Password"
                    required
                />

                <button type="submit">Complete Setup</button>
            </form>
        </div>
    );
};

export default AccountSetup; 